module.exports = __webpack_public_path__ + "media/assets/images/flags/qa-8089411c5e62f6b4686ffe37b1d7e99c.svg";